export const AVETTI_STAGING =
	'https://punchoutgateway2.avetti.ca/preview/validatetranstoken.ajx'
export const AVETTI_LOCAL =
	'https://punchoutgateway2.avetti.ca/preview/validatetranstoken.ajx'
export const AVETTI_UAT =
	'https://punchoutgateway2.avetti.ca/preview/validatetranstoken.ajx'
export const AVETTI_PROD =
	'https://punchoutgateway2.avetti.ca/preview/validatetranstoken.ajx'
